import { render, staticRenderFns } from "./EditCustomerPrices.vue?vue&type=template&id=59344700"
import script from "./EditCustomerPrices.vue?vue&type=script&lang=js"
export * from "./EditCustomerPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports